import React, { Component } from 'react'
import { Route, Link } from 'react-router-dom'
import InfoList from './InfoList'
import InfoDetail from './InfoDetail'
import { Breadcrumb } from 'antd'
import '../assets/css/infoDisclosure.css'

class InfoDisclosure extends Component {
    render () {
        const { match } = this.props
        return (
            <div>
                <div className="banner-item banner-info">
                    <div className="l-container">
                        <h2>信息披露</h2>
                    </div>
                </div>
                <div className="page-title l-container">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/infoDisclosure">信息披露</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="l-container">
                    {
                     match.isExact && <InfoList/>
                    }
                    <Route path={`${match.url}/:id`} component={ InfoDetail }/>
                </div>
            </div>
        )
    }
}

export default InfoDisclosure
